module.exports = __webpack_public_path__ + "img/icon_page1_line1.d96bc28a.png";